<template>
  <div class="marketing-activity">
    <template v-if="view === 1">
      <div class="main-title">
        <p>
          <span class="bold-text">活动弹窗管理</span>
        </p>
      </div>
      <div class="main-body">
        <div class="filter-bar">
          <div class="item">
            <span>所属组织：</span>
            <el-cascader
              class="fixed-width-200"
              :options="unitList"
              :props="{ checkStrictly: true, value:'unitNo',label:'name',children:'subUnit' }"
              v-model="unitNos"
              clearable></el-cascader>
          </div>
          <div class="item">
            <span>创建时间：</span>
            <el-date-picker placeholder="开始时间" type="datetime" value-format="timestamp"
                            v-model="startTime"></el-date-picker>
            <span>~</span>
            <el-date-picker placeholder="结束时间" type="datetime" value-format="timestamp"
                            v-model="endTime"></el-date-picker>
          </div>
          <div class="item">
            <el-button type="primary" @click="getDataList">查询</el-button>
            <el-button type="primary" @click="showForm(1)">新增</el-button>
          </div>
        </div>

        <table class="table-custom" style="margin-top: 20px">
          <thead>
          <tr>
            <th>活动名称</th>
            <th>所属组织</th>
            <th>内容类型</th>
            <th>启用状态</th>
            <th>弹窗内容</th>
            <th>创建时间</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody v-if="dataList.length>0">
          <tr v-for="(item, index) in dataList" :key="index">
            <td>{{ item.name }}</td>
            <td>{{ item.unitNameList.join(" > ") }}</td>
            <td>{{ item.typeDesc }}</td>
            <td>{{ item.enableStatusDesc }}</td>
            <td>
              <span v-if="item.type === '1'">{{ item.content }}</span>
              <el-image style="width: 100px" fit="fill" v-if="item.type === '2'" :src="item.imageSrc" alt=""></el-image>
            </td>
            <td>{{ parseTime(item.createTime) }}</td>
            <td>
              <el-button type="primary" size="mini" @click="showForm(2, item)">编辑</el-button>
              <el-button type="primary" size="mini" @click="onDelete(item.number)">删除</el-button>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="7" style="text-align: center">暂无数据</td>
          </tr>
          </tbody>
        </table>
        <div class="page-box">
          <div class="page-count">第{{ currentPage }}页，当前页{{ dataList.length }}条，共{{ total }}条</div>
          <div class="page-count">
            跳转到第
            <el-input v-model="page" class="page-choose fixed-width-35" size="mini"></el-input>
            页
          </div>
          <div class="page-count text-btn" @click="toPage">跳转</div>
          <div class="pre-btn" :class="beginIndex <= 0 ? 'disabled' : ''" @click="prevPage">上一页</div>
          <div class="next-btn" :class="reachEnd ? 'disabled' : ''" @click="nextPage">下一页</div>
        </div>
      </div>
    </template>
    <marketing-activity-form v-else :type="formType" :data="formData" @back="back"
                             :unit-list="unitList"></marketing-activity-form>
  </div>
</template>

<script>
import marketingActivityForm from "./marketingActivityForm";
import {parseTime} from "../../utils";

export default {
  name: "marketingActivity",
  components: {marketingActivityForm},
  data() {
    const currentTime = new Date().getTime();
    return {
      startTime: '',
      endTime: currentTime,
      unitNos: [],
      unitList: [],
      dataList: [],
      beginIndex: 0,
      pageSize: 10,
      total: 0,
      page: '',
      reachEnd: true,
      formType: 1,
      formData: {},
      view: 1, // 1 列表  2 表单,
      parseTime
    }
  },

  computed: {
    currentPage() {
      return Math.floor(this.beginIndex / this.pageSize) + 1
    },
    totalPage() {
      return Math.ceil(this.total / this.pageSize)
    }
  },

  mounted() {
    this.getUnitMember();
    this.getDataList();
  },

  methods: {

    onDelete(number) {
      this.$confirm("确定要删除吗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http.post('/managementPlatform/admin/deleteMarketingActivity', this.$qs.stringify({number})
        ).then(response => {
          let res = response.data;
          if (!res || !res.result) {
            return this.$message.error(res.message)
          }
          this.$message.success("操作成功");
          this.getDataList();
        }).catch(function (response) {
          console.log(response);
        });
      })
    },

    back(needRefresh) {
      this.view = 1;
      if (needRefresh) {
        this.endTime = new Date().getTime() + 1000;
        this.getDataList();
      }
    },

    getUnitMember() {
      let params = {
        authorityType: 201
      }
      this.$http.post('/managementPlatform/unit/queryManagedUnit', this.$qs.stringify(params)
      ).then(response => {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        this.unitList = res.mdata.unitTree;
      }).catch(function (response) {
        console.log(response);
      });
    },

    getDataList() {
      let params = {
        unitNo: this.unitNos[this.unitNos.length - 1] || '',
        startTime: this.startTime,
        endTime: this.endTime,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1
      }
      this.$http.get('/managementPlatform/admin/getMarketingActivityList?' + this.$qs.stringify(params)
      ).then(response => {
        let res = response.data;
        if (!res || !res.result) {
          return this.$message.error(res.message)
        }
        this.reachEnd = res.ldata.length < this.pageSize + 1;
        if (!this.reachEnd) {
          res.ldata.pop();
        }
        res.ldata.forEach(ele => {
          ele.registerTime = parseTime(ele.registerTime) || '';
          ele.receivingTime = parseTime(ele.receivingTime) || '';
        })
        this.dataList = res.ldata;
        this.total = res.mdata.total || '0'
      }).catch(function (response) {
        console.log(response);
      });
    },

    toPage() {
      if (!this.page || isNaN(this.page)) {
        return this.$message.warning("请输入跳转的页数");
      }
      this.page = parseInt(this.page);
      if (this.pageSize < 1 || this.page > this.totalPage) {
        return this.$message.warning("请输入正确的页码");
      }
      this.beginIndex = (this.page - 1) * this.pageSize;
      this.getDataList();
    },

    prevPage() {
      this.beginIndex -= this.pageSize;
      this.getDataList();
    },

    nextPage() {
      this.beginIndex += this.pageSize;
      this.getDataList();
    },

    showForm(formType, data) {
      if (formType === 2) {
        this.formData = {...data};
      } else {
        this.formData = {}
      }
      this.formType = formType;
      this.view = 2;
    }
  }
}
</script>

<style lang="scss" scoped>
.marketing-activity {
  .filter-bar {
    display: flex;
    align-items: center;

    .item {
      margin-right: 10px;
      min-width: 260px;

      .el-input {
        width: 160px;
      }

      .el-cascader,
      .el-select,
      .el-date-editor {
        width: 200px;
      }
    }
  }

  .table-custom {
    th, td {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/marketingMgmt/marketingActivity.vue